import { VenueOutput } from 'js/model/rainbow/venue/VenueOutput';

export const generateVenueTrackingAttributes = (
  venue: VenueOutput,
  triggerContext: string
) => {
  const portfolioImageCount = venue.employees.reduce(
    (sum, employee) => sum + employee.portfolioImages.length,
    0
  );
  const treatments = venue.menu.menuGroups.reduce(
    (sum, group) => sum + group.menuItems.length,
    0
  );

  return {
    country: venue.location.tree.countryCode,
    platform: 'web',
    screen_has_portfolio: portfolioImageCount > 0,
    screen_portfolio_photo_number: portfolioImageCount,
    screen_review_number: venue.rating.count,
    screen_review_score: venue.rating.average,
    screen_treatment_category_number:
      venue.menu.treatmentCategoryGroups?.length,
    screen_treatment_number: treatments,
    screen_venue_photo_number: venue.images.length,
    screen_venue_type: venue.type?.normalisedName,
    trigger_context: triggerContext,
    venue_id: venue.id,
  };
};
